module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Cooking/Baking-glove-cc18d58f4a3b2b19c7ddf4469c7878c4.svg";